import restful from '@/utils/restful';
import * as names from '@/store/names';
import * as get from '@/store/store';

const state = {
    instructional_designs: [],
    instructional_designs_url: '/teaching/instructional-design'
}

const getters = {
    [names.INSTRUCTIONAL_DESIGNS]: state => {
        if (!get.store.state.user) return [];
        return state.instructional_designs
            .filter((x) => x.school == get.store.state.user.school)
            .sort((a, b) => a.id - b.id);
    },
    [names.INSTRUCTIONAL_DESIGN]: (state,) => id => {
        return state.instructional_designs.find(x => x.id == id);
    },
}

const mutations = {
    [names.MUTATE_INSTRUCTIONAL_DESIGNS]: (state, instructional_designs) => {
        instructional_designs.forEach(element => {
            let index = state.instructional_designs.findIndex(x => x.id == element.id);
            if (index != -1) state.instructional_designs.splice(index, 1, element);
            else state.instructional_designs.push(element);
        });
    },
    [names.MUTATE_INSTRUCTIONAL_DESIGN]: (state, instructional_design) => {
        let index = state.instructional_designs.findIndex(x => x.id == instructional_design.id);
        if (index != -1) state.instructional_designs.splice(index, 1, instructional_design);
        else state.instructional_designs.push(instructional_design);
    },
    [names.MUTATE_DELETE_INSTRUCTIONAL_DESIGN]: (state, instructional_design_id) => {
        let index = state.instructional_designs.findIndex(x => x.id == instructional_design_id);
        if (index != -1) state.instructional_designs.splice(index, 1);
    },
}

const actions = {
    /**
     * El diseño es multi-nivel: se pide por UNO de los tres anclajes.
     * payload: { matter_id | egress_profile_matter_id | section_id, force }
     * El nivel lo decide la vista según `use_matter_values`.
     */
    [names.FETCH_INSTRUCTIONAL_DESIGNS]: ({
        commit,
        state,
    }, payload = {}) => {
        const {
            matter_id = null,
            egress_profile_matter_id = null,
            section_id = null,
            force = false,
        } = payload;
        return new Promise((resolve) => {
            let query = '';
            let matches = () => false;
            if (matter_id != null) {
                query = `?matter=${matter_id}`;
                matches = (x) => x.matter == matter_id;
            } else if (egress_profile_matter_id != null) {
                query = `?egress_profile_matter=${egress_profile_matter_id}`;
                matches = (x) => x.egress_profile_matter == egress_profile_matter_id;
            } else if (section_id != null) {
                query = `?section=${section_id}`;
                matches = (x) => x.section == section_id;
            }
            if (!force) {
                const cached = state.instructional_designs.filter(matches);
                if (cached.length > 0) {
                    resolve(cached);
                    return;
                }
            }
            restful.GetAll(`${state.instructional_designs_url}/${query}`)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_DESIGNS, response);
                    resolve(response);
                });
        });
    },
    /**
     * Devuelve el diseño del nivel pedido y lo CREA vacío si no existe.
     * Es la vía recomendada al abrir la vista (evita el "no existe todavía").
     * payload: { matter_id | egress_profile_matter_id | section_id }
     */
    [names.RESOLVE_INSTRUCTIONAL_DESIGN]: ({
        commit,
        state,
    }, payload = {}) => {
        const {
            matter_id = null,
            egress_profile_matter_id = null,
            section_id = null,
        } = payload;
        let query = '';
        if (matter_id != null) query = `?matter=${matter_id}`;
        else if (egress_profile_matter_id != null) query = `?egress_profile_matter=${egress_profile_matter_id}`;
        else if (section_id != null) query = `?section=${section_id}`;
        return new Promise((resolve, reject) => {
            if (!query) {
                reject(new Error('RESOLVE_INSTRUCTIONAL_DESIGN requiere un nivel.'));
                return;
            }
            restful.Get(`${state.instructional_designs_url}/resolve/${query}`)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_DESIGN, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.POST_INSTRUCTIONAL_DESIGN]: ({
        commit,
        state
    }, instructional_design) => {
        return new Promise((resolve) => {
            restful.Post(`${state.instructional_designs_url}/`, instructional_design)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_DESIGN, response);
                    resolve(response);
                });
        });
    },
    // payload: { instructional_design_id, item }
    [names.PATCH_INSTRUCTIONAL_DESIGN]: ({
        commit,
        state
    }, payload) => {
        return new Promise((resolve) => {
            restful.Patch(`${state.instructional_designs_url}/${payload.instructional_design_id}/`, payload.item)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_DESIGN, response);
                    resolve(response);
                });
        });
    },
    [names.DELETE_INSTRUCTIONAL_DESIGN]: ({
        commit,
        state
    }, instructional_design_id) => {
        return new Promise((resolve) => {
            restful.Delete(`${state.instructional_designs_url}/${instructional_design_id}/`)
                .then(response => {
                    commit(names.MUTATE_DELETE_INSTRUCTIONAL_DESIGN, instructional_design_id);
                    resolve(response);
                });
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};
